import { memo, useMemo } from 'react';
import { Box } from '@mui/material';
import BillDetails from '../../CartDrawer/BillDetails';
import { formatPriceFromCents } from '../../../Utils/UtilsFunctions';

/**
 * Cart summary with bill details and note
 * Memoized to prevent unnecessary re-renders
 */
const CartSummary = memo(
  ({ apiPricingData, orderType, note, dispatch, storeData }) => {
    // Memoized display values
    const displayValues = useMemo(() => {
      if (!apiPricingData) {
        return {
          subtotal: '0.00',
          total: '0.00',
          tax: '0.00',
          modifiers: '0.00',
          discounts: '0.00',
          serviceCharge: '0.00',
          onlineFee: '0.00',
        };
      }

      return {
        subtotal: formatPriceFromCents(apiPricingData.subtotal || 0),
        total: formatPriceFromCents(apiPricingData.total || 0),
        tax: formatPriceFromCents(apiPricingData.tax || 0),
        modifiers: formatPriceFromCents(
          apiPricingData.total_modifiers_price || 0
        ),
        discounts: formatPriceFromCents(apiPricingData.total_discounts || 0),
        serviceCharge: formatPriceFromCents(
          (apiPricingData.serviceChargeMoney || 0) -
            (apiPricingData.onlineFee || 0)
        ),
        onlineFee: formatPriceFromCents(apiPricingData.onlineFee || 0),
      };
    }, [apiPricingData]);

    return (
      <>
        {/* Bill Details */}
        <Box sx={{ padding: '16px 5%' }}>
          <BillDetails
            type={orderType || 'pickup'}
            displayTotal={displayValues.total}
            displaySubtotal={displayValues.subtotal}
            backendTax={displayValues.tax}
            displayModifiersPrice={displayValues.modifiers}
            totalDiscounts={displayValues.discounts}
            displayDeliveryFee={displayValues.serviceCharge}
            displayOnlineFee={displayValues.onlineFee}
            taxesText={apiPricingData?.taxes_text}
            storeData={storeData}
          />
        </Box>
      </>
    );
  }
);

CartSummary.displayName = 'CartSummary';

export default CartSummary;
